export default {
    newest: 'Neueste',
    oldest: 'Letzte',
    noEntries: 'Keine Einträge gefunden',

    demo: {
        openAi: "Open Ai Demo"
    },

    general: {
        organisationNews:  'Neuigkeiten'
    },

    processes: {
        title: 'Maßnahmen in "Gestartet"',
        tableIndex: 'Übersicht Maßnahmen in "Gestartet"'
    },

    paymentRuns: {
        title: 'Letzte Zahlungsläufe',
        tableIndex: 'Übersicht letzte Zahlungsläufe',
        id: 'Zahlungslauf #',
    },
}